export default "__VITE_PUBLIC_ASSET__265e164f__"